import React from 'react';
import { Box, Menu } from '@mui/material';

import { RadioButtonIcon } from '@/components';

import { BodyWrapper, SymbolFontElement, Label } from './styles';

const SymbolFontSelectMenu = props => {
  const { open, selected, onSelect, list, setOpen, anchorEl } = props;

  const handleClick = symbolFontObj => {
    onSelect(symbolFontObj.value);
    setOpen(false);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      height="520px"
      onClose={() => setOpen(false)}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 1.5,
          '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <BodyWrapper>
        {list?.map(symbolFontObj => {
          const { value, label } = symbolFontObj;
          return (
            <SymbolFontElement onClick={() => handleClick(symbolFontObj)} key={value} selected={selected === value}>
              <Box sx={{ display: 'flex' }}>
                <RadioButtonIcon checked={selected === value} />
              </Box>
              <Label>{label}</Label>
            </SymbolFontElement>
          );
        })}
      </BodyWrapper>
    </Menu>
  );
};

export default React.memo(SymbolFontSelectMenu);
